import React from 'react';
import { keyLiveProjects, skills } from '../content_helper';

const Home = () => {
  const featuredProjects = keyLiveProjects.filter(p => ['metrash', 'qatar-rail', 'hayya'].includes(p.id));
  return (
    <main className="pt-24">
        {/*  Hero Section  */}
        <section
            className="max-w-container-max mx-auto px-margin-page py-stack-lg flex flex-col md:flex-row items-center gap-gutter">
            <div className="flex-1 space-y-stack-md">
                <div
                    className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass-panel text-primary font-semibold text-xs tracking-wide">
                    <span className="relative flex h-2 w-2">
                        <span
                            className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                    </span>
                    AVAILABLE FOR ARCHITECTURAL ROLES
                </div>
                <h1 className="font-display text-headline-xl text-primary max-w-2xl leading-tight">
                    Dineshkumar Nataraj
                    <span className="block text-on-surface mt-2 font-light">Senior Full Stack &amp; Mobile Developer</span>
                </h1>
                <p className="text-body-lg text-on-surface-variant max-w-xl leading-relaxed">
                    With over 6 years of engineering excellence, I specialize in building robust, high-scale digital
                    ecosystems for government and enterprise clients using React, Next.js, and React Native.
                </p>
                <div className="flex flex-wrap gap-4 pt-6">
                    <button
                        className="px-8 py-3.5 bg-primary text-on-primary font-bold rounded-lg transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(125,211,252,0.4)]">
                        Get in Touch
                    </button>
                    <button
                        className="px-8 py-3.5 glass-panel border-primary/30 text-primary font-bold rounded-lg hover:bg-primary/10 transition-all">
                        View GitLab
                    </button>
                </div>
            </div>
            <div className="flex-1 w-full relative">
                <div
                    className="aspect-[1.46] rounded-2xl overflow-hidden border border-primary/20 shadow-2xl glass-panel group relative">
                    <img alt="Portfolio Preview"
                        className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                        data-alt="A high-fidelity screenshot of a professional developer portfolio website showcased on a dark, sleek laptop screen. The background is a minimalist studio setting with deep navy blue and slate grey tones, illuminated by soft cyan accent lighting that emphasizes the technical and sophisticated nature of the work. The layout of the portfolio on screen features a clean grid of project thumbnails and bold sans-serif typography, reflecting a high-performance, architectural design language."
                        src="https://lh3.googleusercontent.com/aida-public/AB6AXuCLYa9DAYOSmenfSG6qAHOAzf6zbkumWIYkDdZO13MA1KOVUy0DE0moXNe87QNViBMHI0yzrIhRFYvxS8KaUaW_sJ5HWsuBMzcdOQY2JDHU49JE-TVF-1nOsM21-8T-o-KpiATpmpIhzi-yHXWxhb_tnIhaQDh9POex8Rmo2cI28V32kMjo_WOMbLEClNXy_aLVvA51suqfSckrSahh7Kzgk41uqNLfY0xSmUBENVxuZUzlABslqX_3HdWFhH9moqu0QNz-46RqT-s" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent"></div>
                </div>
                {/*  Decorative elements  */}
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-primary/20 blur-[80px] rounded-full"></div>
                <div className="absolute -bottom-20 -left-10 w-64 h-64 bg-tertiary/10 blur-[100px] rounded-full"></div>
            </div>
        </section>
        {/*  Highlights Bar  */}
        <section className="bg-surface-container-lowest/50 backdrop-blur-sm border-y border-primary/10 py-16">
            <div className="max-w-container-max mx-auto px-margin-page grid grid-cols-2 md:grid-cols-4 gap-gutter">
                <div className="text-center group">
                    <div className="text-primary font-display text-4xl mb-2 transition-transform group-hover:scale-110">6+
                        </div>
                    <div className="text-on-surface-variant font-semibold text-xs uppercase tracking-[0.2em]">Years
                        Experience</div>
                        </div>
                <div className="text-center group">
                    <div className="text-primary font-display text-4xl mb-2 transition-transform group-hover:scale-110">20+
                    </div>
                    <div className="text-on-surface-variant font-semibold text-xs uppercase tracking-[0.2em]">Projects
                        Delivered</div>
                </div>
                <div className="text-center group">
                    <div className="text-primary font-display text-4xl mb-2 transition-transform group-hover:scale-110">App
                    </div>
                    <div className="text-on-surface-variant font-semibold text-xs uppercase tracking-[0.2em]">Store
                        Specialist</div>
                </div>
                <div className="text-center group">
                    <div className="text-primary font-display text-4xl mb-2 transition-transform group-hover:scale-110">IoT
                    </div>
                    <div className="text-on-surface-variant font-semibold text-xs uppercase tracking-[0.2em]">Enthusiast
                    </div>
                </div>
            </div>
        </section>
        {/*  Key Live Projects  */}
        <section className="max-w-container-max mx-auto px-margin-page py-stack-lg">
            <div className="flex flex-col md:flex-row justify-between items-end mb-gutter gap-4">
                <div className="space-y-2">
                    <div className="text-primary font-semibold text-xs tracking-[0.3em] uppercase">Featured Work</div>
                    <h2 className="font-display text-headline-lg text-on-surface">Key Live Projects</h2>
                </div>
                <a className="group text-primary font-semibold text-sm flex items-center gap-2 hover:underline decoration-primary/30 underline-offset-4"
                    href="/projects">
                    View Project Gallery
                    <span
                        className="material-symbols-outlined transition-transform group-hover:translate-x-1">arrow_right_alt</span>
                </a>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-gutter">
                {featuredProjects.map(proj => (
                    <div key={proj.id}
                        className="group relative flex flex-col glass-panel rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:border-primary/50">
                        <div className="h-64 bg-surface-container-high overflow-hidden relative">
                            <img alt={`${proj.name} Project`}
                                className="w-full h-full object-cover transition-all duration-700 scale-105 group-hover:scale-100"
                                src={proj.image} />
                            <div className="absolute inset-0 bg-primary/10 mix-blend-overlay"></div>
                        </div>
                        <div className="p-stack-md flex-1 flex flex-col">
                            <div className="flex justify-between items-start mb-3">
                                <h3 className="font-headline text-2xl text-primary">{proj.name}</h3>
                                <span className="material-symbols-outlined text-primary/60">{proj.icon}</span>
                            </div>
                            <p className="text-body-md text-on-surface-variant mb-6 leading-relaxed">{proj.description}</p>
                            <div className="mt-auto flex flex-wrap gap-2">
                                {proj.tech.slice(0, 2).map(t => (
                                    <span key={t} className="px-3 py-1 bg-primary/10 text-primary font-medium text-xs rounded-full border border-primary/20">{t}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
        {/*  Experience Timeline Preview  */}
        <section className="max-w-container-max mx-auto px-margin-page py-stack-lg border-t border-primary/10">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-gutter">
                <div className="md:col-span-4 space-y-4">
                    <h2 className="font-display text-headline-lg text-on-surface">Professional Journey</h2>
                    <p className="text-on-surface-variant leading-relaxed">Specializing in the intersection of mobile
                        excellence and scalable web backends with a focus on high-reliability infrastructure.</p>
                </div>
                <div className="md:col-span-8 space-y-12">
                    <div className="relative pl-8 border-l-2 border-primary/20">
                        <div className="absolute -left-[9px] top-2 w-4 h-4 bg-primary rounded-full ring-4 ring-primary/10">
                        </div>
                        <div className="text-xs font-bold text-primary tracking-widest mb-2">2023 — PRESENT</div>
                        <h4 className="font-headline text-2xl mb-2">Senior Full Stack Engineer</h4>
                        <p className="text-on-surface-variant leading-relaxed">Delivered Metrash, CMS (Strapi), Qatar Rail, and Hayya platforms at national scale. Implemented payment systems, push notifications, and secure APIs. Improved UI performance and reduced load times. Led multilingual implementation (Arabic/English).</p>
                    </div>
                    <div className="relative pl-8 border-l-2 border-primary/20">
                        <div
                            className="absolute -left-[9px] top-2 w-4 h-4 bg-surface-variant rounded-full border-2 border-primary/40">
                        </div>
                        <div className="text-xs font-bold text-on-surface-variant tracking-widest mb-2">2021 — 2023</div>
                        <h4 className="font-headline text-2xl mb-2">Web and Mobile App Developer</h4>
                        <p className="text-on-surface-variant leading-relaxed">React & React Native
                            applications with AWS IoT integrations and real-time syncing.</p>
                    </div>
                    <div className="relative pl-8 border-l-2 border-primary/20">
                        <div
                            className="absolute -left-[9px] top-2 w-4 h-4 bg-surface-variant rounded-full border-2 border-primary/40">
                        </div>
                        <div className="text-xs font-bold text-on-surface-variant tracking-widest mb-2">2020 — 2021</div>
                        <h4 className="font-headline text-2xl mb-2">Junior Full Stack Developer</h4>
                        <p className="text-on-surface-variant leading-relaxed">Worked React & React Native projects
                            with complex IoT integrations and real-time syncing.</p>
                    </div>
                </div>
            </div>
        </section>
        {/*  Technical Stack Console  */}
        <section className="max-w-container-max mx-auto px-margin-page py-stack-lg">
            <div className="glass-panel rounded-2xl overflow-hidden border border-primary/20">
                <div
                    className="bg-surface-container-highest/80 px-6 py-3 flex items-center justify-between border-b border-primary/10">
                    <div className="flex gap-2.5">
                        <div className="w-3.5 h-3.5 rounded-full bg-error/80"></div>
                        <div className="w-3.5 h-3.5 rounded-full bg-secondary/80"></div>
                        <div className="w-3.5 h-3.5 rounded-full bg-primary/80"></div>
                    </div>
                    <div className="font-mono text-xs text-on-surface-variant opacity-80">system_stack_overview.sh</div>
                </div>
                <div className="p-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {Object.entries(skills).map(([category, items]) => {
                        const icons = {
                            frontend: 'web',
                            mobile: 'smartphone',
                            backend: 'database',
                            devops: 'cloud'
                        };
                        return (
                            <div key={category}>
                                <div className="text-primary font-bold text-xs mb-6 flex items-center gap-2 tracking-[0.2em]">
                                    <span className="material-symbols-outlined text-[18px]">{icons[category] || 'code'}</span> 
                                    {category.toUpperCase()}
                                </div>
                                <ul className="space-y-4 text-on-surface-variant text-sm">
                                    {items.slice(0, 4).map((item, idx) => (
                                        <li key={idx} className="flex items-center gap-3">
                                            <span className="w-2 h-2 bg-primary/60 rounded-full"></span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    </main>
  );
};

export default Home;
